import React, { useEffect, useState } from "react";
import axios from "axios";
import serverConfig from "../config";
import "./Home.css";
import "./CallsAwards.css";
import SecondaryMenu from "../SecondaryMenu";

import toast, { Toaster } from "react-hot-toast";
function AnnouncementsDsm() {
  const [contentAnnouncementsDsm, setContentAnnouncementsDsm] = useState(null);

  useEffect(() => {
    axios
      .get(`${serverConfig.serverUrl}/get_announcements_dsm`)
      .then((response) => {
        const data = response.data;
        setContentAnnouncementsDsm(data);
      })
      .catch((error) => {
        toast.error("La risorsa non è al momento disponibile");
      });
  }, []);

  const viewImg = (img) => {
    const src = `${serverConfig.serverUrl}/img/announcements_dsm/${img}`; // Percorso dell'immagine
    const handleImageError = (event) => {
      event.target.src = ""; // Imposta l'immagine di fallback su una stringa vuota per evitare il loop di ricaricamento
      event.target.style.backgroundColor = "white"; // Imposta lo sfondo bianco
    };
    return (
      <div className="circle-chat-list">
        <img
          src={src}
          alt={`Immagine ${img}`}
          style={{
            width: "400px",
            height: "150px",
            display: "block",
            backgroundColor: "transparent", // Imposta lo sfondo trasparente per mostrare il bianco dietro in caso di errore
          }}
          onError={handleImageError} // Ascolta l'evento onError per gestire l'errore di caricamento dell'immagine
          draggable={false}
        />
      </div>
    );
  };

  const handleDownloadClick = (event, fileUrl) => {
    event.preventDefault();
    axios
      .get(`${serverConfig.serverUrl}/file/announcements_dsm/${fileUrl}`, {
        responseType: "blob", // Indica ad Axios che la risposta è un blob (file)
      })
      .then((response) => {
        const blob = new Blob([response.data]);
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = fileUrl.split("/").pop();
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      })
      .catch((error) => {
        //alert("'Errore durante il download del file");
        toast.error("La risorsa non è al momento scaricabile");
      });
  };

  const [showDetails, setShowDetails] = useState(false);
  const [selectedAnnouncement, setSelectedAnnouncement] = useState(null);

  const [hoverTimeout, setHoverTimeout] = useState(null);

  const handleMouseEnter = (component) => {
    // Cancella un eventuale timer precedente per evitare conflitti
    if (hoverTimeout) clearTimeout(hoverTimeout);

    // Imposta un nuovo timer di 1 secondo
    const timeout = setTimeout(() => {
      setShowDetails(true);
      setSelectedAnnouncement(component);
    }, 500); // 1000 ms = 1 secondo

    // Salva il timer nello stato
    setHoverTimeout(timeout);
  };

  const handleMouseLeave = () => {
    // Cancella il timer se il mouse lascia il componente prima che il timeout finisca
    if (hoverTimeout) {
      clearTimeout(hoverTimeout);
      setHoverTimeout(null);
    }

    // Nasconde i dettagli
    setShowDetails(false);
    setSelectedAnnouncement(null);
  };

  const renderAnnouncements = (items) => {
    const pairs = [];
    for (let i = 0; i < items.length; i += 2) {
      pairs.push(items.slice(i, i + 2));
    }

    return (
      <div className="conference-items" style={{ marginBottom: "20px" }}>
        <div
          style={{
            color: "#F5F7FA",
            textAlign: "center",
            fontSize: "20px",
            borderRadius: "10px",
            border: "2px solid #D8DEE9",
            backgroundColor: "#003366",
          }}
        >
          {items[0]["date"].slice(0, 4)}
        </div>
        {pairs.map((pair, pairIndex) => (
          <div className="row" key={pairIndex}>
            {pair.map((item, itemIndex) => (
              <div className="col-12 col-lg-6" key={itemIndex}>
                <div
                  style={{
                    borderRadius: "10px",
                    border: "1px solid #003366",
                    padding: "10px",
                    backgroundColor: "#F5F7FA",
                  }}
                  onMouseEnter={() => handleMouseEnter(item)}
                  onMouseLeave={handleMouseLeave}
                >
                  <div
                    style={{
                      color: "#F5F7FA",
                      textAlign: "center",
                      fontSize: "15px",
                      borderRadius: "10px",
                      //backgroundColor: "#003366",

                      backgroundColor: "rgba(0, 51, 102, 0.8)",
                      marginBottom: '10px'
                    }}
                  >
                    <strong

                    >
                      {item.dayDate} {item.date}
                      {" "}<br></br>
                      {item.title}
                    </strong>
                  </div>

                  <div>
                    {item.img && item.img !== "" && (
                      <div className="row" style={{ textAlign: "center" }}>
                        <div>{viewImg(item.img)}</div>
                      </div>
                    )}
                    <div className="row">
                      {item.text && item.text !== "" && (
                        <div dangerouslySetInnerHTML={{ __html: item.text }} />
                      )}
                      {item.file && item.file !== "" && (
                        <div>
                          {/*}
                            <a
                              href={`${serverConfig.serverUrl}/file/calls_awards/${item.file}`}
                              download
                              rel="noopener noreferrer"
                              style={{ marginRight: "20px" }}
                              onClick={(e) => handleDownloadClick(e, item.file)}
                              draggable={false}
                              onDragStart={(e) => e.preventDefault()}
                            >
                              <button
                                style={{
                                  borderRadius: "5px",
                                  backgroundColor: "#003366",
                                  border: "white",
                                  color: "white",
                                  cursor: "pointer",
                                }}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="16"
                                  height="16"
                                  fill="currentColor"
                                  className="bi bi-file-earmark-arrow-down"
                                  viewBox="0 0 16 16"
                                  style={{ marginRight: "10px" }}
                                >
                                  <path d="M8.5 6.5a.5.5 0 0 0-1 0v3.793L6.354 9.146a.5.5 0 1 0-.708.708l2 2a.5.5 0 0 0 .708 0l2-2a.5.5 0 0 0-.708-.708L8.5 10.293z" />
                                  <path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2M9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5z" />
                                </svg>
                                DOWNLOAD THE FILE - {item.file}
                              </button>
                            </a>
                            */}

                          <div style={{ marginTop: "10px" }}>
                            <button
                              className="btn btn-outline-primary"
                              onClick={() =>
                                window.open(
                                  `${serverConfig.serverUrl}/file/announcements_dsm/${item.file}`,
                                  "_blank"
                                )
                              }
                            >
                              APRI IN UNA NUOVA FINESTRA
                            </button>
                            <a
                              href={`${serverConfig.serverUrl}/file/announcements_dsm/${item.file}`}
                              download
                              className="btn btn-primary ms-2"
                              onClick={(e) => handleDownloadClick(e, item.file)}
                            >
                              SCARICA
                            </a>
                          </div>
                        </div>
                      )}
                      {item.link && item.link !== "" && (
                        <div style={{ marginTop: "10px" }}>
                          <button
                            className="btn btn-outline-primary"
                            onClick={() =>
                              window.open(`${item.link}`, "_blank")
                            }
                          >
                            APRI IN UNA NUOVA FINESTRA
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ))}
      </div>
    );
  };

  const viewAnnouncements = (
    <>
      {contentAnnouncementsDsm && (
        <div>
          {Object.entries(contentAnnouncementsDsm)
            .sort((a, b) => parseInt(b[0]) - parseInt(a[0]))
            .map(([group, items]) => (
              <div key={group}>{renderAnnouncements(items)}</div>
            ))}
        </div>
      )}
    </>
  );
  const [showSidebar, setShowSidebar] = useState(window.innerWidth > 992);

  const handleResize = () => {
    if (window.innerWidth > 992) {
      setShowSidebar(true);
    } else {
      setShowSidebar(false);
    }
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const componentAnnouncementsDsm = <>{viewAnnouncements}</>;
  return (
    <div>
      <div
        className={`row home-container ${
          showSidebar ? "show-sidebar" : "hide-sidebar"
        }`}
      >
        <Toaster />
        <button
          className="show-sidebar-button"
          onClick={() => setShowSidebar(!showSidebar)}
        >
          {showSidebar ? "Nascondi Menu" : "Mostra Menu"}
        </button>

        {window.innerWidth <= 992 ? (
          showSidebar ? (
            <div className="col-12">
              <SecondaryMenu vertical={true}></SecondaryMenu>
            </div>
          ) : (
            <div className={`main-content col-12`}>
              {componentAnnouncementsDsm}
            </div>
          )
        ) : (
          <>
            <div className="col-2 sidebar-left">
              <SecondaryMenu vertical={true}></SecondaryMenu>
            </div>
            <div
              className={`main-content ${showSidebar ? "col-10" : "col-12"}`}
            >
              {componentAnnouncementsDsm}
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default AnnouncementsDsm;
